import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useRestoreScroll from '../../hooks/useRestoreScroll.js'

const Privacy = () => {
    const navigate = useNavigate()
    const [activeSection, setActiveSection] = useState('data-controller')
    useRestoreScroll()
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])

    const sections = [
        { id: 'data-controller', title: '1. Data Controller' },
        { id: 'data-categories', title: '2. Data Categories' },
        { id: 'legal-basis', title: '3. Legal Basis' },
        { id: 'purposes', title: '4. Purposes' },
        { id: 'sharing', title: '5. Data Sharing' },
        { id: 'cross-border', title: '6. Cross-Border Transfers' },
        { id: 'security', title: '7. Data Security' },
        { id: 'retention', title: '8. Retention & Deletion' },
        { id: 'rights', title: '9. Your Rights' },
        { id: 'updates', title: '10. Policy Updates' },
        { id: 'liability', title: '11. Disclaimer of Liability' },
        { id: 'pet-photos', title: '12. Use of Pet Photos' },
        { id: 'governing-law', title: '13. Governing Law' }
    ]

    const scrollToSection = (sectionId) => {
        setActiveSection(sectionId)
        const element = document.getElementById(sectionId)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    // Styles
    const sectionTitleStyle = {
        fontSize: '24px',
        fontWeight: 600,
        color: '#1F2937',
        margin: '48px 0 24px 0',
        paddingTop: '20px'
    }

    const contentStyle = {
        fontSize: '16px',
        lineHeight: 1.7,
        color: '#374151'
    }

    const listStyle = {
        paddingLeft: '24px',
        margin: '16px 0'
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: '#F9FAFB',
            fontFamily: '"Red Hat Display", sans-serif'
        }}>
            {/* Header */}
            <div style={{
                background: '#FFFFFF',
                borderBottom: '1px solid #E5E7EB',
                padding: '16px 0',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '0 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        cursor: 'pointer'
                    }} onClick={() => navigate('/social')}>
                        <img
                            src="/icons/navbar/Sulhafa_Beta_Logo.png"
                            alt="Sulhafa Logo"
                            width={120}
                            height={40}
                        />
                    </div>

                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            background: 'transparent',
                            border: '1px solid #E5E7EB',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            fontFamily: '"Red Hat Display", sans-serif',
                            fontSize: '14px',
                            color: '#6B7280',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#F9FAFB'
                            e.target.style.borderColor = '#D1D5DB'
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'transparent'
                            e.target.style.borderColor = '#E5E7EB'
                        }}
                    >
                        ← Back
                    </button>
                </div>
            </div>

            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '32px 24px',
                display: 'flex',
                gap: '32px'
            }}>
                {/* Sidebar Navigation */}
                <div style={{
                    width: '280px',
                    flexShrink: 0
                }}>
                    <div style={{
                        background: '#FFFFFF',
                        borderRadius: '12px',
                        padding: '24px',
                        border: '1px solid #E5E7EB',
                        position: 'sticky',
                        top: '100px',
                        maxHeight: 'calc(100vh - 120px)',
                        overflow: 'auto'
                    }}>
                        <h3 style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            color: '#1F2937',
                            margin: '0 0 20px 0'
                        }}>
                            Table of Contents
                        </h3>
                        <nav>
                            {sections.map((section) => (
                                <button
                                    key={section.id}
                                    onClick={() => scrollToSection(section.id)}
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        textAlign: 'left',
                                        border: 'none',
                                        padding: '12px 16px',
                                        margin: '4px 0',
                                        borderRadius: '8px',
                                        fontFamily: '"Red Hat Display", sans-serif',
                                        fontSize: '14px',
                                        color: activeSection === section.id ? '#8548A8' : '#6B7280',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        fontWeight: activeSection === section.id ? 500 : 400,
                                        background: activeSection === section.id ? '#F3E8FF' : 'transparent',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeSection !== section.id) {
                                            e.target.style.background = '#F9FAFB'
                                            e.target.style.color = '#374151'
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeSection !== section.id) {
                                            e.target.style.background = 'transparent'
                                            e.target.style.color = '#6B7280'
                                        }
                                    }}
                                    title={section.title}
                                >
                                    {section.title}
                                </button>
                            ))}
                        </nav>
                    </div>
                </div>

                {/* Main Content */}
                <div style={{
                    flex: 1,
                    background: '#FFFFFF',
                    borderRadius: '12px',
                    padding: '40px',
                    border: '1px solid #E5E7EB'
                }}>
                    <div style={{
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        {/* Page Header */}
                        <div style={{
                            textAlign: 'center',
                            marginBottom: '48px'
                        }}>
                            <h1 style={{
                                fontSize: '32px',
                                fontWeight: 700,
                                color: '#1F2937',
                                margin: '0 0 16px 0'
                            }}>
                                Privacy Policy & Data Collection
                            </h1>
                            <p style={{
                                fontSize: '16px',
                                color: '#6B7280',
                                margin: '0 0 8px 0'
                            }}>
                                Last updated: {new Date().toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </p>
                        </div>

                        {/* 1. Data Controller Information */}
                        <section id="data-controller">
                            <h2 style={{ ...sectionTitleStyle, marginTop: '0' }}>
                                1. Data Controller Information
                            </h2>
                            <div style={contentStyle}>
                                <p>The Data Controller under applicable data protection laws is:</p>
                                <ul style={listStyle}>
                                    <li><strong>Legal Entity:</strong> Rubiks Company</li>
                                    <li><strong>Registered in:</strong> Kingdom of Saudi Arabia</li>
                                    <li><strong>Contact Email:</strong> support@sulhafa.com</li>
                                </ul>
                            </div>
                        </section>

                        {/* 2. Categories of Data We Collect */}
                        <section id="data-categories">
                            <h2 style={sectionTitleStyle}>
                                2. Categories of Data We Collect
                            </h2>
                            <div style={contentStyle}>
                                <p>We may collect and process the following categories of personal data:</p>
                                <ul style={listStyle}>
                                    <li><strong>Personal Information:</strong> Name, email, phone number, residential address</li>
                                    <li><strong>Pet Information:</strong> Species, breed, age, medical history, vaccination records, Pet image</li>
                                    <li><strong>Location Data:</strong> GPS tracking (opt-in), service proximity</li>
                                    <li><strong>Behavioral Data:</strong> App usage, preferences, interaction logs</li>
                                    <li><strong>Payment Data:</strong> Billing information, transaction history</li>
                                    <li><strong>Device Data:</strong> IP address, browser type, operating system, cookies</li>
                                </ul>
                            </div>
                        </section>

                        {/* 3. Legal Basis for Processing */}
                        <section id="legal-basis">
                            <h2 style={sectionTitleStyle}>
                                3. Legal Basis for Processing
                            </h2>
                            <div style={contentStyle}>
                                <p>We process your personal data based on the following lawful bases:</p>
                                <ul style={listStyle}>
                                    <li><strong>Consent:</strong> For location tracking, marketing communications, and cookies</li>
                                    <li><strong>Contractual Necessity:</strong> To provide the services requested by you</li>
                                    <li><strong>Legal Obligation:</strong> To comply with regulatory and statutory requirements</li>
                                    <li><strong>Legitimate Interest:</strong> To improve platform performance, prevent fraud, and enhance security</li>
                                </ul>
                            </div>
                        </section>

                        {/* 4. Purposes of Processing */}
                        <section id="purposes">
                            <h2 style={sectionTitleStyle}>
                                4. Purposes of Processing
                            </h2>
                            <div style={contentStyle}>
                                <p>Your data is processed for the following purposes:</p>
                                <ul style={listStyle}>
                                    <li>Delivering veterinary and pet-related services</li>
                                    <li>Personalizing your experience and generating AI-based insights</li>
                                    <li>Processing payments and managing subscriptions</li>
                                    <li>Enhancing platform functionality and conducting analytics</li>
                                    <li>Sending service updates and promotional offers (with opt-out option)</li>
                                    <li>Complying with legal obligations and responding to lawful requests</li>
                                </ul>
                            </div>
                        </section>

                        {/* 5. Data Sharing & Third Parties */}
                        <section id="sharing">
                            <h2 style={sectionTitleStyle}>
                                5. Data Sharing & Third Parties
                            </h2>
                            <div style={contentStyle}>
                                <p>Your personal data may be shared with the following, under strict confidentiality and data protection obligations:</p>
                                <ul style={listStyle}>
                                    <li>Verified veterinary professionals and service providers</li>
                                    <li>Payment processors, logistics, and delivery partners</li>
                                    <li>Government authorities, regulators, or law enforcement (where legally required)</li>
                                    <li>Cloud hosting and IT service providers (with contractual safeguards)</li>
                                </ul>
                                <p>We do not sell, trade, or rent your personal data to advertisers or unrelated third parties.</p>
                            </div>
                        </section>

                        {/* 6. Cross-Border Data Transfers */}
                        <section id="cross-border">
                            <h2 style={sectionTitleStyle}>
                                6. Cross-Border Data Transfers
                            </h2>
                            <div style={contentStyle}>
                                <p>If personal data is transferred outside the Kingdom of Saudi Arabia, the UAE, or Jordan:</p>
                                <ul style={listStyle}>
                                    <li>We implement appropriate safeguards such as encryption, contractual clauses, or equivalent mechanisms.</li>
                                    <li>Transfers are conducted in compliance with Saudi PDPL, UAE Federal Decree-Law No. 45 of 2021, and relevant Jordanian data protection requirements.</li>
                                </ul>
                            </div>
                        </section>

                        {/* 7. Data Security */}
                        <section id="security">
                            <h2 style={sectionTitleStyle}>
                                7. Data Security
                            </h2>
                            <div style={contentStyle}>
                                <p>We adopt industry-standard technical and organizational measures, including:</p>
                                <ul style={listStyle}>
                                    <li>End-to-end encryption for sensitive data</li>
                                    <li>Role-based access controls for internal personnel</li>
                                    <li>Regular security audits and vulnerability assessments</li>
                                    <li>Cloud infrastructure compliant with ISO 27001 standards</li>
                                </ul>
                            </div>
                        </section>

                        {/* 8. Data Retention & Deletion */}
                        <section id="retention">
                            <h2 style={sectionTitleStyle}>
                                8. Data Retention & Deletion
                            </h2>
                            <div style={contentStyle}>
                                <p>We retain your personal data only for as long as necessary to fulfill the purposes stated herein or as required by law:</p>
                                <ul style={listStyle}>
                                    <li><strong>Pet health records:</strong> Up to 5 years, unless longer retention is required by law</li>
                                    <li><strong>Account information:</strong> Retained until you close your account or request deletion</li>
                                    <li><strong>Deletion rights:</strong> You may request deletion of your data at any time by contacting support@sulhafa.com</li>
                                </ul>
                            </div>
                        </section>

                        {/* 9. Your Data Protection Rights */}
                        <section id="rights">
                            <h2 style={sectionTitleStyle}>
                                9. Your Data Protection Rights
                            </h2>
                            <div style={contentStyle}>
                                <p>In line with applicable laws, you have the right to:</p>
                                <ul style={listStyle}>
                                    <li><strong>Access:</strong> Obtain confirmation and details of personal data we hold about you</li>
                                    <li><strong>Correction:</strong> Request rectification of inaccurate or outdated data</li>
                                    <li><strong>Deletion:</strong> Request erasure of your personal data</li>
                                    <li><strong>Objection:</strong> Object to processing for direct marketing or profiling</li>
                                    <li><strong>Portability:</strong> Receive a copy of your data in a structured, machine-readable format</li>
                                </ul>
                                <p>Requests may be submitted via support@sulhafa.com</p>
                            </div>
                        </section>

                        {/* 10. Policy Updates */}
                        <section id="updates">
                            <h2 style={sectionTitleStyle}>
                                10. Policy Updates
                            </h2>
                            <div style={contentStyle}>
                                <p>We reserve the right to update or amend this Privacy Policy periodically:</p>
                                <ul style={listStyle}>
                                    <li>Any material changes will be communicated via email or in-app notifications</li>
                                    <li>Continued use of our services constitutes acceptance of such updates.</li>
                                </ul>
                            </div>
                        </section>

                        {/* 11. Disclaimer of Liability for Service Providers */}
                        <section id="liability">
                            <h2 style={sectionTitleStyle}>
                                11. Disclaimer of Liability for Service Providers
                            </h2>
                            <div style={contentStyle}>
                                <p>
                                    The User acknowledges and agrees that Sulhafa Platform shall not be held liable, whether contractually or legally, for the performance of independent service providers engaged through the Platform. In the event of any damage, loss, or claim arising from the acts or omissions of a service provider, the User expressly agrees that any recourse shall be sought directly against the service provider, and that no liability of any kind shall be attributed to Sulhafa Platform.
                                </p>
                            </div>
                        </section>

                        {/* 12. Use of Pet Photos */}
                        <section id="pet-photos">
                            <h2 style={sectionTitleStyle}>
                                12. Use of Pet Photos
                            </h2>
                            <div style={contentStyle}>
                                <p>The User agrees that Sulhafa Platform may collect, store, and use pet photos uploaded through the Platform for the following purposes:</p>
                                <ol style={{ paddingLeft: '24px', margin: '16px 0' }}>
                                    <li>Maintaining and managing the pet’s medical and service-related records.</li>
                                    <li>Enhancing and improving the services provided through the Platform.</li>
                                    <li>Using such photos in the Platform’s marketing and promotional materials (while ensuring that no personal data or identifiable user information is disclosed without the User’s explicit consent).</li>
                                </ol>
                            </div>
                        </section>

                        {/* 13. Governing Law & Jurisdiction */}
                        <section id="governing-law">
                            <h2 style={sectionTitleStyle}>
                                13. Governing Law & Jurisdiction
                            </h2>
                            <div style={contentStyle}>
                                <p>This Privacy Policy is governed by:</p>
                                <ul style={listStyle}>
                                    <li>The Saudi Personal Data Protection Law (PDPL)</li>
                                    <li>UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data</li>
                                    <li>Jordanian Electronic Transactions Law, where applicable</li>
                                </ul>
                                <p>Disputes arising hereunder shall be subject to the exclusive jurisdiction of the courts of Riyadh, KSA, or Amman, Jordan, depending on the user’s location.</p>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Privacy
